import { createSelector } from 'reselect';

import { saveSearchSelector } from '../root/saveSearchSelector';

export const jsonQuerySaveSearchSelector = createSelector(saveSearchSelector, saveSearch => saveSearch.jsonQuery);
